<template>
  <div class="banner">
    <img src="../images/Abc_Games_Banner.png" alt="" class="bg_img" />
    <b-img
      src="../images/PLAY NOW.png"
      alt=""
      class="btn_common btn_play"
      @click="goPlay()"
    />
    <b-img
      src="../images/download.png"
      alt=""
      class="btn_common btn_download"
      @click="goDownload()"
    />
  </div>
</template>

<script>
import down from "../../urlConfig";
export default {
  data() {
    return {};
  },
  methods: {
    goPlay() {
      window.location.href = "https://cdn.abcgames.online/index.html";
    },
    goDownload() {
      let url = down.downloadUrl;
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.setAttribute("download", "abcgames.apk");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  position: relative;
}
.bg_img {
  width: 100%;
  object-fit: contain;
  height: 100%;
}
.btn_common {
  width: 31vw;
  object-fit: contain;
  position: absolute;
  right: 10.5vw;
  cursor: pointer;
}
.btn_play {
  bottom: 2%;
}
.btn_download {
  bottom: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue